import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url === environment.pushNotificationUrl) {
      request.url;
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: `Basic ${environment.apiKey}`,
        },
      });
      //console.log(request);
      return next.handle(request);
    } else if (request.url === environment.aiURL) {
      request.url;
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${environment.aiApiKey}`,
        },
      });
      //console.log(request);
      return next.handle(request);
    } else if (request.headers.get('Authorization') !== 'CHG Token') {
      request.url;
      request = request.clone({
        setHeaders: {
          'Content-Type': request.url.includes('mediafile')
            ? 'multipart/form-data'
            : 'application/json',
          Authorization: this.auth.currentToken
            ? `Token ${this.auth.currentToken.key}`
            : '', // this.auth.getToken() ? `Token ${this.auth.getToken()}`:''
        },
      });
      return next.handle(request);
    } else {
      //Creacion de un usuario admin escuela con limites
      request.url;
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: 'Token 22fbb51ff577366086695452910826eb6dfa9d9b',
        },
      });
      //console.log(request);
      return next.handle(request);
    }
  }
}
